import type { CreateReturnRequestDto, ReturnRequestDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";
import { SESSION_TOKEN_KEY } from "./use-session-token";

const authHeader = () => ({ authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}` });

export async function publicCreateReturnRequest(
	body: CreateReturnRequestDto,
): Promise<ReturnRequestDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		{ params: { header: authHeader() }, body: body as any },
	);
	if (error) throw error;
	return data as ReturnRequestDto;
}

export function usePublicCreateReturnRequest() {
	return usePublicApiMutation(
		"post",
		"/public/return-request",
		{
			mapVariables: (body: CreateReturnRequestDto) => ({
				params: { header: authHeader() },
				body,
			}),
		},
	);
}
